import { Modal } from 'react-bootstrap'
import AlertIcon from '../../atoms/Icons/AlertIcon'
import CustomButton from '../../Button/CustomButton'

function ModalCheckSuggest(props) {
  const { data, onHide } = props
  return (
    <Modal {...props} centered>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column justify-content-center py-2">
          <div className="d-flex justify-content-center">
            <AlertIcon width="131" height="130" />
          </div>
          <div className="d-flex justify-content-center">
            <p
              className="fs-5 text-center mt-3"
              style={{ lineHeight: '2rem', width: '70%' }}
            >
              Some items don’t have slot suggestion yet! Please set for these
              item code:{' '}
              {data.length > 0 ? (
                <b>{data.map((item) => item).join(', ')}</b>
              ) : (
                ''
              )}
            </p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="mt-3">
        <CustomButton
          text="Oke"
          variant="transparent"
          classNameValue="btn-primary-orange"
          onClick={onHide}
          style={{ width: '65px' }}
        />
      </Modal.Footer>
    </Modal>
  )
}

export default ModalCheckSuggest
